import { FUND_SECTIONS as TRUST_SECTIONS } from './fundSections';
import { BANK_INVESTOR_SECTIONS } from './bankInvestorSections';
import type { SetupField, SetupSection } from './fieldTypes';
import { CLASS_SECTION } from './classSection';
import { ACTIVATE_SECTION, OFFER_SECTIONS } from './offerSections';

const FUND_SECTIONS = [...TRUST_SECTIONS, ...BANK_INVESTOR_SECTIONS];

export const SETUP_SECTIONS: SetupSection[] = [
  ...FUND_SECTIONS,
  CLASS_SECTION,
  ACTIVATE_SECTION,
  ...OFFER_SECTIONS,
];

export const ALL_FIELDS: SetupField[] = SETUP_SECTIONS.flatMap((section) =>
  section.blocks.flatMap((block) => block.fields),
);

export const ACTIVATION_SECTIONS = [...FUND_SECTIONS.map((section) => section.id), 'class'];

export const OFFER_FORM_SECTIONS = OFFER_SECTIONS.filter((section) => section.id !== 'review').map(
  (section) => section.id,
);

export function sectionById(id: string): SetupSection | undefined {
  return SETUP_SECTIONS.find((section) => section.id === id);
}
